module.exports = __webpack_public_path__ + "92f121d3d6a3b6a6d0237f768c8c7c55.png";